import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  MenuItem,
  CircularProgress,
  Autocomplete,
  Chip,
} from "@mui/material";

import { useForm, Controller } from "react-hook-form";

import { toast } from "react-toastify";

import { useNavigate, useParams } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import {
  getVoucherMetadata,
  createVoucher,
  getVoucherDetail,
  updateVoucher,
  checkVoucherCode,
} from "../../apis/cart/apis";
import { getAllUsers } from "../../apis/user";
import { ImageCropper } from "../../components/CommonFunctions/ImageCropper";
import { debounce } from "lodash";

// const steps = ["Voucher Details", "Restrictions", "Offers"];

const CreateVoucherScreen = () => {
  const fileInputRef = useRef(null);
  const { id } = useParams();
  const [initialEligibleUsers, setInitialEligibleUsers] = useState([]);
  const isEdit = Boolean(id);
  console.log("isEdit:", isEdit);
  console.log("id:", id);
  const navigate = useNavigate();

  const {
    control,
    trigger,
    getValues,
    setValue,
    setError,
    reset,
    watch,
    handleSubmit: rhfHandleSubmit,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      code: "",
      usage: "",
      audience_type: "",
      display_type: "none",
      start_datetime: moment().toISOString(),
      end_datetime: "",
      offers: "",
      eligible_users: [],
      image: null,
    },
  });
  const [cropperOpen, setCropperOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImageUrl, setCroppedImageUrl] = useState("");
  const audienceType = watch("audience_type");
  const voucherCode = watch("code");
  const [debouncedCode, setDebouncedCode] = useState("");
  const [metadata, setMetadata] = useState({
    usage_types: [],
    audience_types: [],
    offers: [],
    display_types: [],
  });

  //   const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const fetchMetadata = useCallback(async () => {
    try {
      const response = await getVoucherMetadata();
      setMetadata(response.data);
      if (response.data.usage_types?.length > 0) {
        setValue("usage", response.data.usage_types[2].value);
      }
    } catch (error) {
      console.log(error);
    }
  }, [setValue]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedCode(voucherCode?.trim() || "");
    }, 500);

    return () => clearTimeout(timer);
  }, [voucherCode]);
  useEffect(() => {
    if (!debouncedCode) {
      return;
    }

    const checkCode = async () => {
      try {
        const response = await checkVoucherCode(
          debouncedCode,
          isEdit ? id : null,
        );

        if (response.data.exists) {
          setError("code", {
            type: "manual",
            message: "Voucher code already exists.",
          });
        } else {
          await trigger("code");
        }
      } catch (error) {
        console.log(error);
      }
    };

    checkCode();
  }, [debouncedCode, id, isEdit, setError, trigger]);

  useEffect(() => {
    fetchMetadata();
  }, [fetchMetadata]);
  useEffect(() => {
    if (!isEdit) {return;}

    const fetchVoucher = async () => {
      try {
        const response = await getVoucherDetail(id);

        const voucher = response.data;
        setInitialEligibleUsers(voucher.eligible_users || []);
        console.log(voucher);
        console.log("eligible_users:", voucher.eligible_users);
        reset({
          name: voucher.name,
          code: voucher.code,
          usage: voucher.usage,
          audience_type: voucher.audience_type,
          display_type: voucher.display_type,
          start_datetime: voucher.start_datetime || "",
          end_datetime: voucher.end_datetime || "",
          offers: voucher.offers[0] || "",
          eligible_users: voucher.eligible_users || [],
          image: voucher.image,
        });
        setCroppedImageUrl(voucher.image || "");
      } catch (error) {
        console.log(error);
      }
    };

    fetchVoucher();
  }, [id, isEdit, reset]);
  //   useEffect(() => {
  //     fetchMetadata();
  //   }, []);
  const selectedOffer = metadata.offers.find(
    (offer) => Number(offer.id) === Number(watch("offers")),
  );
  const onSubmit = async (data) => {
    try {
      if (
        selectedOffer &&
        moment(data.end_datetime).isAfter(moment(selectedOffer.end_datetime))
      ) {
        setError("end_datetime", {
          type: "manual",
          message: `Voucher end date cannot be later than the offer end date (${moment(
            selectedOffer.end_datetime,
          ).format("DD MMM YYYY, hh:mm A")}).`,
        });
        return;
      }
      if (
        selectedOffer &&
        moment(data.start_datetime).isBefore(
          moment(selectedOffer.start_datetime),
        )
      ) {
        setError("start_datetime", {
          type: "manual",
          message: `Voucher start date cannot be earlier than the offer start date (${moment(
            selectedOffer.start_datetime,
          ).format("DD MMM YYYY, hh:mm A")}).`,
        });
        return;
      }

      setLoading(true);

      setLoading(true);

      if (isEdit) {
        const formData = new FormData();

        formData.append("name", data.name);
        // formData.append("code", data.code);
        data.eligible_users.forEach((user) => {
          formData.append(
            "eligible_users",
            typeof user === "object" ? user.id : user,
          );
        });

        // Upload new image only if user selected one
        if (croppedImageUrl?.startsWith("blob:")) {
          const response = await fetch(croppedImageUrl);
          const blob = await response.blob();

          formData.append("image", blob, "voucher.jpg");
        }
        // data.eligible_users.forEach((user) => {
        //   formData.append("eligible_users", user.id);
        // });
        // for (const [key, value] of formData.entries()) {
        //   console.log(key, value);
        // }
        await updateVoucher(id, formData);

        toast.success("Voucher updated successfully");
      } else {
        const formData = new FormData();

        formData.append("name", data.name);
        formData.append("code", data.code);
        formData.append("usage", data.usage);
        formData.append("audience_type", data.audience_type);
        formData.append("display_type", data.display_type);

        if (data.start_datetime) {
          formData.append("start_datetime", data.start_datetime);
        }

        if (data.end_datetime) {
          formData.append("end_datetime", data.end_datetime);
        }

        if (data.offers) {
          formData.append("offers", data.offers);
        }

        data.eligible_users.forEach((user) => {
          formData.append("eligible_users", user.id);
        });

        if (croppedImageUrl) {
          const response = await fetch(croppedImageUrl);
          const blob = await response.blob();

          formData.append("image", blob, "voucher.jpg");
        }

        await createVoucher(formData);

        toast.success("Voucher created successfully");
      }

      navigate("/w86zjruk6q/vouchers/");
    } catch (error) {
      console.log(error);

      if (error?.response?.data?.code) {
        setError("code", {
          type: "server",
          message: error.response.data.code[0],
        });
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  const [inputLoading, setInputLoading] = useState(false);
  const requestId = useRef(0);

  const debouncedFetch = useMemo(
    () =>
      debounce(async (query) => {
        const id = ++requestId.current;

        setInputLoading(true);

        try {
          const res = await getAllUsers(10, 1, {
            search: query,
          });

          // Ignore stale responses
          if (id !== requestId.current) {return;}

          setUsers(res.results || []);
        } finally {
          if (id === requestId.current) {
            setInputLoading(false);
          }
        }
      }, 1000),
    [],
  );

  const mergedOptions = useMemo(() => {
    const selected = getValues("eligible_users") || [];

    const map = new Map();

    [...selected, ...users].forEach((user) => {
      map.set(user.id, user);
    });

    return [...map.values()];
  }, [users, getValues]);

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  //   const renderStepContent = () => {
  //     switch (activeStep) {
  //       case 0:
  //         return (
  //           <Grid container spacing={2}>
  //             <Grid item xs={12}>
  //               <Controller
  //                 name="name"
  //                 control={control}
  //                 rules={{
  //                   required: "Voucher Name is required",
  //                 }}
  //                 render={({ field, fieldState }) => (
  //                   <TextField
  //                     {...field}
  //                     fullWidth
  //                     label="Voucher Name"
  //                     error={!!fieldState.error}
  //                     helperText={fieldState.error?.message}
  //                   />
  //                 )}
  //               />
  //             </Grid>

  //             <Grid item xs={12}>
  //               <Controller
  //                 name="code"
  //                 control={control}
  //                 rules={{
  //                   required: "Voucher Code is required",
  //                 }}
  //                 render={({ field, fieldState }) => (
  //                   <TextField
  //                     {...field}
  //                     fullWidth
  //                     label="Voucher Code"
  //                     error={!!fieldState.error}
  //                     helperText={fieldState.error?.message}
  //                   />
  //                 )}
  //               />
  //             </Grid>

  //             <Grid item xs={12}>
  //               <Controller
  //                 name="usage"
  //                 control={control}
  //                 rules={{
  //                   required: "Usage is required",
  //                 }}
  //                 render={({ field, fieldState }) => (
  //                   <TextField
  //                     {...field}
  //                     value={field.value || ""}
  //                     select
  //                     fullWidth
  //                     label="Usage"
  //                     error={!!fieldState.error}
  //                     helperText={fieldState.error?.message}
  //                   >
  //                     <MenuItem value="">Select Usage</MenuItem>

  //                     {metadata.usage_types.map((item) => (
  //                       <MenuItem key={item.value} value={item.value}>
  //                         {item.label}
  //                       </MenuItem>
  //                     ))}
  //                   </TextField>
  //                 )}
  //               />
  //             </Grid>
  //           </Grid>
  //         );

  //       default:
  //         return null;
  //     }
  //   };
  const voucherStart = watch("start_datetime");
  return (
    <Box p={3}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          {isEdit ? "Update Voucher" : "Create Voucher"}
        </Typography>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <Controller
              name="name"
              control={control}
              rules={{
                required: "Voucher Name is required",
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Voucher Name"
                  required
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="code"
              control={control}
              rules={{
                required: "Voucher Code is required",
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Voucher Code"
                  disabled={isEdit}
                  required
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="usage"
                control={control}
                rules={{
                  required: "Usage is required",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    disabled={isEdit}
                    label="Usage"
                    required
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                    <MenuItem value="">Select Usage</MenuItem>

                    {metadata.usage_types.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="audience_type"
                control={control}
                // disabled={isEdit}
                rules={{
                  required: "Audience Type is required",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    disabled={isEdit}
                    label="Audience Type"
                    required
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                    <MenuItem value="">Select Audience Type</MenuItem>

                    {metadata.audience_types.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}
          {audienceType === "eligible_users" && (
            <Grid item xs={12}>
              <Controller
                name="eligible_users"
                control={control}
                rules={{
                  validate: (value) =>
                    value?.length > 0 || "Please select at least one user",
                }}
                render={({ field, fieldState }) => (
                  <Autocomplete
                    multiple
                    filterOptions={(x) => x}
                    loading={inputLoading}
                    options={mergedOptions}
                    value={field.value || []}
                    getOptionLabel={(option) => option.title ?? ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, value) => {
                      if (isEdit) {
                        const existingIds = new Set(
                          initialEligibleUsers.map((user) => user.id),
                        );

                        const newUsers = value.filter(
                          (user) => !existingIds.has(user.id),
                        );

                        field.onChange([...initialEligibleUsers, ...newUsers]);
                      } else {
                        field.onChange(value);
                      }

                    }}
                    // Optional: clear search results
                    //   setUsers([]);
                    // }}
                    filterSelectedOptions
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.title}
                      </li>
                    )}
                    noOptionsText={
                      inputLoading ? "Searching..." : "No users found"
                    }
                    onInputChange={(_, input, reason) => {
                      if (reason !== "input") {return;}

                      if (!input.trim()) {
                        debouncedFetch.cancel();
                        setUsers([]);
                        return;
                      }
                      debouncedFetch(input);
                    }}
                    disableCloseOnSelect
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const tagProps = getTagProps({ index });

                        const isExisting =
                          isEdit &&
                          initialEligibleUsers.some(
                            (user) => user.id === option.id,
                          );

                        return (
                          <Chip
                            key={option.id}
                            label={option.title}
                            {...tagProps}
                            onDelete={
                              isExisting ? undefined : tagProps.onDelete
                            }
                          />
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Eligible Users"
                        // disabled={isEdit}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {inputLoading && <CircularProgress size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          )}
          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="display_type"
                disabled={isEdit}
                control={control}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    select
                    fullWidth
                    label="Display Type"
                  // error={!!fieldState.error}
                  // helperText={fieldState.error?.message}
                  >
                    {metadata.display_types.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}
          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="offers"
                disabled={isEdit}
                control={control}
                rules={{
                  required: "Please select an offer",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    label="Offer"
                    required
                    disabled={isEdit}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                    <MenuItem value="">Select Offer</MenuItem>

                    {metadata.offers.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="start_datetime"
                    control={control}
                    rules={{
                      required: "Start Date is required",
                    }}
                    render={({ field, fieldState }) => (
                      <DateTimePicker
                        label="Start Date"
                        value={field.value ? moment(field.value) : null}
                        onChange={(value) =>
                          field.onChange(value ? value.toISOString() : "")
                        }
                        disabled={isEdit || !selectedOffer}
                        minDateTime={
                          selectedOffer?.start_datetime
                            ? moment(selectedOffer.start_datetime)
                            : undefined
                        }
                        maxDateTime={
                          selectedOffer?.end_datetime
                            ? moment(selectedOffer.end_datetime)
                            : undefined
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Controller
                    name="end_datetime"
                    control={control}
                    rules={{
                      required: "End Date is required",
                      validate: (value) => {
                        const start = getValues("start_datetime");

                        if (
                          start &&
                          value &&
                          moment(value).isBefore(moment(start))
                        ) {
                          return "End date must be after the start date.";
                        }

                        return true;
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <DateTimePicker
                        label="End Date"
                        value={field.value ? moment(field.value) : null}
                        onChange={(value) =>
                          field.onChange(value ? value.toISOString() : "")
                        }
                        disabled={!isEdit && !selectedOffer}
                        minDateTime={
                          voucherStart
                            ? moment(voucherStart)
                            : selectedOffer?.start_datetime
                              ? moment(selectedOffer.start_datetime)
                              : undefined
                        }
                        maxDateTime={
                          selectedOffer?.end_datetime
                            ? moment(selectedOffer.end_datetime)
                            : undefined
                        }
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="image"
              control={control}
              render={({ field }) => (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    {croppedImageUrl ? "Change Image" : "Upload Image"}
                  </Button>

                  <input
                    ref={fileInputRef}
                    hidden
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];

                      if (!file) {return;}

                      //   setSelectedImage(file);
                      setSelectedImage(URL.createObjectURL(file));
                      setCropperOpen(true);

                      // DON'T call field.onChange here if you're cropping
                    }}
                  />

                  {croppedImageUrl && (
                    <Typography sx={{ mt: 1 }}>voucher.jpg</Typography>
                  )}
                  {croppedImageUrl && (
                    <Box mt={2}>
                      <img
                        src={croppedImageUrl}
                        alt="Voucher"
                        style={{
                          width: 200,
                          borderRadius: 8,
                        }}
                      />
                    </Box>
                  )}

                  <ImageCropper
                    open={cropperOpen}
                    setOpen={setCropperOpen}
                    image={selectedImage}
                    aspect={3 / 4}
                    setImage={(croppedImage) => {
                      setCroppedImageUrl(croppedImage);
                      field.onChange({
                        name: "voucher.jpg",
                      });
                    }}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
              }}
            >
              <Button
                variant="contained"
                disabled={loading || !isValid}
                onClick={rhfHandleSubmit(onSubmit)}
              >
                {loading ? (
                  <CircularProgress size={20} />
                ) : isEdit ? (
                  "Update Voucher"
                ) : (
                  "Create Voucher"
                )}
              </Button>

              {/* <input
                ref={fileInputRef}
                hidden
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0];

                  if (!file) return;

                  setSelectedImage(URL.createObjectURL(file));
                  setCropperOpen(true);
                }}
              /> */}
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default CreateVoucherScreen;
